<template>
  <section class="intro-section" aria-labelledby="front-page-title">
    <div class="edition-meta"><span>Front Page</span><span>Filed under: Open systems</span></div>
    <div class="intro-grid">
      <div class="hero-copy">
        <p class="eyebrow">Case No. 07 · Findings in progress</p>
        <h1 id="front-page-title">A software developer following systems all the way down.</h1>
        <p class="standfirst">I’m Ray — a software developer with seven years of practical experience, now moving deliberately toward cybersecurity.</p>
        <div class="hero-links">
          <a href="#projects">Read the work <span>→</span></a>
          <a href="mailto:icydrae@hotmail.com">Get in touch <span>→</span></a>
        </div>
      </div>
      <figure class="headshot">
        <img src="../../../assets/Good portrait 2 pixelated.png" alt="Ray">
        <figcaption>Pictured: the subject, usually near a terminal and a difficult problem.</figcaption>
      </figure>
      <aside class="statistics" aria-label="Career highlights">
        <div><strong>7+</strong><span>Years building software</span></div>
        <div><strong>10K+</strong><span>Users supported</span></div>
        <div><strong>MS + Google</strong><span>Certified</span></div>
      </aside>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Intro',
  data() {
    return {

    }
  }
}
</script>
